import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, userProfile } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // Allow access if email is confirmed OR phone is verified via profile
  const emailConfirmed = !!user.email_confirmed_at;
  const phoneVerified = userProfile?.phone_verified === true;

  if (!emailConfirmed && !phoneVerified) {
    return <Navigate to="/admin/verify-required" replace />;
  }

  return <>{children}</>;
}
